// extracted by css-extract-rspack-plugin
export default {"state":"state--W1Dw1KBy6Dw_YZIu","stateDiscard":"state_discard--tKHvoMruzUjats2H"};